export default __webpack_public_path__ + "static/media/prize-3-cn.1464e521.webp";